import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosService from "../../../services/axiosServicesVisit";

export const getClinicReports = createAsyncThunk(
  'clinicReports/get',
  async ({ pageNumber, limit, filter }, thunkAPI) => {
    try {
      const params = new URLSearchParams({
        page: pageNumber,
        limit: limit,
        ...filter
      });
      
      // --- MISE À JOUR DE L'URL ---
      const response = await axiosService.get(`/v1/report-clinics?${params.toString()}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);